import api from 'api';
import { PayrollGetUserByIdArgs } from '../types';
import { AppError } from 'utils/AppError';
import { GetFnfDismissalDateSchemaContract } from 'schemas/GetFnfDismissalDateSchema';

export const getDismissalDate = async (
  args: PayrollGetUserByIdArgs,
): Promise<GetFnfDismissalDateSchemaContract> => {
  try {
    const [user, monolithDates] = await Promise.all([
      api.userQueries.getUserbyId(args),
      api.fnf.getDismissalDate(Number(args.userId)),
    ]);
    const deactivateDate = user.payrollGetUser.data.deactivateDate as string | null | undefined;
    return {
      deactivate_date: deactivateDate ?? monolithDates.deactivate_date ?? null,
      resignation_date: monolithDates.resignation_date ?? null,
    };
  } catch (e: Error | any) {
    throw new AppError({ messageForUser: e.message });
  }
};
